/**
 * Table row hover — matches designTokens.tableRowHover
 */
import { figmaTokens } from "assets/theme/designTokens";

const tableRow = {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: `${figmaTokens.tableRowHover} !important`,
      },
    },
  },
};

export default tableRow;
